import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { queueThunks } from './queueThunks';
import type { QueueState } from './queueTypes';

const initialState: QueueState = { items: [], byId: {}, currentItem: null, status: 'idle', error: null, totalCount: 0 };

export const queueSlice = createSlice({
  name: 'queues',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCrudCases(builder, queueThunks, (q) => q.queueId);
  },
});

export const queueReducer = queueSlice.reducer;
